import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48895455"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_5 = { class: "box_image" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 星汉未来智能运维解决方案 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(" 基于业务指标的监控及精准度量能力，"),
          _hoisted_3,
          _createTextVNode(" 对AWS、阿里云等各个云平台上的基础设施、各类算力进行统一管理及极速调度，实现业务的快速发布部署、各个业务间的算力共享。"),
          _hoisted_4,
          _createTextVNode(" 通过决策支持平台全面展示业务全景信息，并提供专业的决策建议和决策动作入口，大幅提升运维决策效率及合理性。 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          alt: "",
          src: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD)?$data.file.ImagePC:$data.file.ImageMobile
        }, null, 8 /* PROPS */, _hoisted_6)
      ])
    ])
  ]))
}